import { Injectable } from '@angular/core';
import { ParsedCoordinatePair } from './models/coordinate-search.model';

@Injectable({
  providedIn: 'root',
})
export class CoordinateValidatorService {
  isValidPair(pair: ParsedCoordinatePair | null): pair is ParsedCoordinatePair {
    if (!pair) {
      return false;
    }
    const { lat, lng } = pair;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return false;
    }
    return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
  }

  /** Reject lone numeric tokens (DB search must handle those). */
  isLikelySingleNumericToken(input: string): boolean {
    const trimmed = input.trim();
    if (!trimmed) {
      return false;
    }
    const single = trimmed.match(/^[+-]?\d+(?:\.\d+)?$/);
    return !!single;
  }
}
